import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Button from '../../../sitewide/Button'
import EmailBodyEditor from '../../EmailBodyEditor'
import PlainTextEditor from '../../PlainTextEditor'
import characterCountMessage from '../../../../services/character-count'
import {
  verifyThumbsUpThumbsDown,
  verifyStars,
  verifySocialUrl,
} from '../../utils'
import styles from '../../OpenChairMessageEditor/styles.css'
import '../styles.css'

class PostApptReviewMessage extends Component {
  state = {
    textChange: false,
  }

  saveMessageSetting = () => {
    const { handleSave } = this.props
    this.setState({ textChange: false })
    handleSave()
  }

  updateTextChange = (newState, oldState) => {
    const { textChange } = this.state
    const sameContent =
      newState.getCurrentContent() === oldState.getCurrentContent()
    if (!sameContent && !textChange) {
      this.setState({ textChange: true })
    }
  }

  subjectUpdate = (newEditorState) => {
    const { subjectState, updateSubjectState } = this.props
    this.updateTextChange(newEditorState, subjectState)
    updateSubjectState(newEditorState)
  }

  bodyUpdate = (newEditorState) => {
    const { bodyState, updateBodyState } = this.props
    this.updateTextChange(newEditorState, bodyState)
    updateBodyState(newEditorState)
  }

  render() {
    const {
      title,
      isEmail,
      bodyState,
      subjectState,
      setting: { message_setting_subtype: subtype },
      maxChars,
    } = this.props
    const { textChange } = this.state

    const messageContainerStyles = cx(styles.container, {
      [styles.welcomeEmailContainer]: isEmail,
      [styles.confirmationTextContainer]: !isEmail,
    })

    const emptyConfText =
      !isEmail && !bodyState.getCurrentContent().getPlainText().trim()
    const characterCount = bodyState.getCurrentContent().getPlainText().length
    const approachingMaxChars = characterCount > maxChars - 20 && !isEmail
    const exceedsMaxChars = characterCount > maxChars && !isEmail
    const validEmail =
      isEmail &&
      bodyState.getCurrentContent().hasText() &&
      subjectState.getCurrentContent().hasText()
    const hasTUTD = verifyThumbsUpThumbsDown(bodyState)
    const hasStars = verifyStars(bodyState)
    const hasSocial = verifySocialUrl(bodyState)
    const isInitialRequest = subtype === 'initial_request'

    const charCountCss = cx(styles.characterCount, {
      [styles.approachingMaxChars]: approachingMaxChars,
      [styles.exceedsMaxChars]: exceedsMaxChars,
    })

    const saveDisabled =
      !textChange ||
      (!validEmail && isEmail) ||
      (!hasSocial && !hasTUTD && !hasStars && isInitialRequest && isEmail) ||
      ((hasTUTD || hasStars) && (!isInitialRequest || !isEmail))

    return (
      <div className={`${messageContainerStyles} CallTextSettingEditor`}>
        <h3>{title}</h3>
        <div className={styles.editorWrapper}>
          {isEmail && (
            <PlainTextEditor
              {...this.props}
              updateSubjectState={this.subjectUpdate}
            />
          )}
          <div className={styles.bodyEditor}>
            {isEmail ? (
              <EmailBodyEditor
                {...this.props}
                updateBodyState={this.bodyUpdate}
              />
            ) : (
              <PlainTextEditor
                {...this.props}
                updateBodyState={this.bodyUpdate}
              />
            )}
            <div className={styles.buttonWrapper}>
              <Button
                disabled={saveDisabled}
                onClick={this.saveMessageSetting}
                paddingTB="7px"
                paddingLR="30px"
              >
                {textChange ? 'Save' : 'Saved'}
              </Button>
              {emptyConfText && (
                <span className={styles.confirmationNote}>
                  NOTE: A confirmation text will not be sent if this editor is
                  left blank
                </span>
              )}
            </div>
            {!isEmail && characterCount > 0 && (
              <div className={charCountCss}>
                {characterCountMessage(characterCount, maxChars)}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

PostApptReviewMessage.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.shape({
    text: PropTypes.string,
  }),
  bodyState: PropTypes.shape({
    getCurrentContent: PropTypes.func.isRequired,
  }),
  subtype: PropTypes.string,
  isEmail: PropTypes.bool,
  handleSave: PropTypes.func.isRequired,
  setting: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  subjectState: PropTypes.shape({
    getCurrentContent: PropTypes.func.isRequired,
  }),
  maxChars: PropTypes.number,
  updateBodyState: PropTypes.func.isRequired,
  updateSetting: PropTypes.func.isRequired,
  updateSubjectState: PropTypes.func.isRequired,
}

export default PostApptReviewMessage



// WEBPACK FOOTER //
// ./src/components/Settings/PostApptReviewMessageEditor/PostApptReviewSettingsEditors/index.js